import React, { PureComponent } from 'react'
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Input
  } from 'reactstrap'

export default class PowerImageModal extends PureComponent {
  static defaultProps = {
    itemID: false,
    onConfirm: () => {},
    onCancel: () => {},
    headerLabel: 'Power Image...',
    confirmBtnLabel: 'Confirm',
    cancelBtnLabel: 'Cancel',
    confirmBtnClass: 'btn btn-primary',
    cancelBtnClass: 'btn btn-default',
    showCancel: true,
    submittingLabel: (
      <span>
        Powering... <i className="fa fa-cog fa-spin"/>
      </span>
    ),
  }

  constructor(props) {
    super(props)
    this.state = {
      poweredID: '',
      hasErrors: false
    }
    this.onConfirmClick = this.onConfirmClick.bind(this)
    this.onConfirmCancel = this.onConfirmCancel.bind(this)
    this.onQueryInput = this.onQueryInput.bind(this)
  }

  onConfirmCancel() {
    this.props.onCancel()
  }

  onConfirmClick() {
    if(this.state.poweredID) {
      this.setState({hasErrors: false})
      this.props.onConfirm(this.props.itemID)
    }
    else this.setState({hasErrors: true})
    
  }

  onQueryInput(e) {
    this.setState({ poweredID: e.target.value }, () => {this.props.onChange(this.state.poweredID)} );
  }


  render() {
    const submitDisabled = this.props.buttonsDisabled 
    const submitLabel = this.props.buttonsDisabled
      ? this.props.submittingLabel
      : this.props.confirmBtnLabel

    return (
        <Modal
            isOpen={this.props.open}
            toggle={this.toggle}
            className={this.props.className}
        >
            <ModalHeader toggle={this.props.onClose}>{this.props.headerLabel}</ModalHeader>
            <ModalBody>
              <Input
                type='text'
                name='poweredId'
                id='power-id-input'
                placeholder='Enter Power ID'
                value={this.state.poweredID}
                onChange={this.onQueryInput}
              />
              {this.state.hasErrors && <div className="power-input-error">Please enter a power ID to continue.</div>}
            </ModalBody>
            <ModalFooter>
            <Button
                color="secondary"
                onClick={this.props.onClose}
                disabled={submitDisabled}
            >
                {this.props.cancelBtnLabel}
            </Button>
            <Button
                color="primary"
                onClick={this.onConfirmClick}
                disabled={submitDisabled}
            >
                {submitLabel}
            </Button>
            </ModalFooter>
        </Modal>

    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Components/Modals/PowerImageModal.js